import tNoa from '../src/Assets/Img/turismo-noa.png'
import toDo from '../src/Assets/Img/to-do-list.png'
import cpd from '../src/Assets/Img/campoder.png'
import migo from '../src/Assets/Img/migo.png'
import crypto from '../src/Assets/Img/crypto.png'
import clinica from '../src/Assets/Img/clinica-rc.png'
import toolman from '../src/Assets/Img/toolman.png'
import taller from '../src/Assets/Img/miTaller.png'
import conversro from '../src/Assets/Img/conversor.png'
import Bach from '../src/Assets/Img/bach.png'
import Marvel from '../src/Assets/Img/marvel.png'
import FDA from '../src/Assets/Img/fda.png'


export const portfolio =[
  {
    id: 11,
    img:Marvel,
    nombre: 'Marvel',
    repositorio:'https://github.com/LMBarthaburu/marvel-api',
    link:'https://marvel-api-4.netlify.app/',
    tecnologias:'React',
    descripcion:'Buscador utilizando la api de Marvel, con pagina de detalle de personajes/comics/eventos.',
    categoria: 'proyecto'
  },
  {
    id: 10,
    img:FDA,
    nombre: 'Buscador FDA',
    repositorio:'https://github.com/LMBarthaburu/fda',
    link:'https://fda-test.netlify.app/',
    tecnologias:'React, Material UI',
    descripcion:'Buscador utilizando la api de la FDA que permite buscar medicamentos por nombre genérico, nombre comercial y por fabricante, con página de detalle de productos.',
    categoria: 'proyecto'
  },
  {
    id: 9,
    img:Bach,
    nombre: 'Bach Jardines y Espacios Verdes',
    repositorio:'https://github.com/LMBarthaburu/bach',
    link:'https://www.bachservicios.com/',
    tecnologias:'React',
    descripcion:'Página web corporativa de la empresa Bach. Diseño y producción del sitio web con el fin de publicitar los servicios y planes que ofrecen.',
    categoria: 'web'
  },
  {
    id: 5,
    img:cpd,
    nombre: 'Campoder SRL',
    repositorio:'https://github.com/LMBarthaburu/CamPoder',
    link:'https://campodersrl.com',
    tecnologias:'HTML, CSS, Bootstrap, Javascript, React',
    descripcion:'Página web corporativa para la empresa CamPoder SRL. Se realizp un rediseño de la version anterior de la misma y se agregaron los diferentes catalogos de articulos que comercializa la empresa.',
    categoria: 'web'
  },
  {
    id:8,
    img:taller,
    nombre: 'Mi Taller',
    repositorio:'https://github.com/LMBarthaburu/taller',
    link: 'https://mi-taller.netlify.app/',
    tecnologias:'MERN ',
    descripcion:'Mi taller es una aplicación web para talleres mecanicos que permite a los mismos administrar sus trabajos y tambien ofrece a sus clientes la posibilidad de hacer un seguimiento del estado de la reparación, consultar costos y los trabajos realizados.',
    categoria: 'app'

  },
  {
    id:7,
    img:toolman,
    nombre: 'Toolman',
    repositorio:'https://github.com/LMBarthaburu/toolman',
    link: 'https://toolmantuc.netlify.app/',
    tecnologias:'REACT, Bootstrap',
    descripcion:'Página web corporativa para la empresa Toolman. Se realizo el diseño y producción de la pagina corporativa para mostrar su trabajo a traves de la vinculación con sus redes sociales y ser un instrumento de contacto.',
    categoria: 'web'
  },
  {
    id: 4,
    img:toDo,
    nombre: 'To Do list app',
    repositorio:'https://github.com/LMBarthaburu/To-Do-List',
    link:'https://todo-list-app-example.netlify.app/',
    tecnologias:'HTML, CSS, Javascript',
    descripcion:'Aplicación web que funciona como una lista de tarea pendientes con la posibilidad de editar, eliminar y chequear las tareas ya realizadas. Proyecto realizado con JavaScrip vanilla a modo de practica.',
    categoria: 'proyecto'
  },
  {
    id: 12,
    img:conversro,
    nombre: 'Conversor de unidades',
    repositorio:'https://github.com/LMBarthaburu/unit-converter',
    link:'https://conversor-unidades.netlify.app/',
    tecnologias:'React',
    descripcion:'Conversor de unidades métricas.',
    categoria: 'proyecto',
  },
  {
    id: 1,
    img:crypto,
    nombre: 'CryptoWorld',
    repositorio:'https://github.com/LMBarthaburu/cryptoworld',
    link:'https://crypto-world-info.netlify.app/',
    tecnologias:'HTML, CSS, Bootstrap, Javascript, React (proyecto academico)',
     descripcion:'Da seguimiento a tus cryptos preferidas.',
    categoria: 'proyecto'
  },
  {
    id: 6,
    img:clinica,
    nombre: 'Clinica RC',
    repositorio:'https://github.com/marcosarias21/proyecto-clinica',
    repositorioBackEnd: 'https://github.com/LMBarthaburu/proyecto-clinica-backend',
    link:'https://clinica-rc-24i.netlify.app/',
    tecnologias:'MERN (proyecto academico)',
     descripcion:'Página de turnos para Clinica Rolling Code, con sistema de turnos y panel administrativo.',
    categoria: 'app'
  },
  {
    id: 2,
    img:migo,
    nombre: 'Migo Community',
    repositorio:'https://github.com/LMBarthaburu/red-social',
    link:'https://migo-community.netlify.app/',
    tecnologias:'HTML, CSS, Javascript (proyecto academico)',
    descripcion:'Red social (sin backend).',
      categoria: 'app'
  },
  {
    id: 3,
    nombre: 'Turismo NOA',
    img:tNoa,
    repositorio:'https://github.com/LMBarthaburu/turismo-noa',
    link:'https://turismo-noa.netlify.app/',
    tecnologias:'HTML, CSS, Bootstrap (proyecto academico)',
     descripcion:'Página turística con el fin de promocionar el Norte Argentino.',
    categoria: 'proyecto'
  },
]